import { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";

import Header from "../components/NewHeader";

import { useProject } from "../contexts/new-project.context";
import { httpRequest } from '../utils/http.util';
import { useError } from '../contexts/error.context';

export default function GlobalLayout() {
  const { projectName, setProjectName } = useProject();
  const { projectId: urlProjectId } = useParams();
  const { handleAPIError } = useError();
  const [shouldShowProjectName, setShouldShowProjectName] = useState(false);

  // Fetch project data when projectId exists in URL
  useEffect(() => {
    const fetchProjectData = async () => {
      if (urlProjectId) {
        try {
          const response = await httpRequest({
            method: "GET",
            url: `/concept_testing/${urlProjectId}/project_details`,
            isAuthRequired: true,
          });
          const data = response.data;
          
          // Only set project name and show it if the project has a latest_run_id
          if (data.latest_run_id) {
            setProjectName(data.project_name || '');
            setShouldShowProjectName(true);
          } else {
            setProjectName('');
            setShouldShowProjectName(false);
          }
        } catch (error) {
          handleAPIError(error);
          setProjectName('');
          setShouldShowProjectName(false);
        }
      } else {
        // Reset when no project ID
        setProjectName('');
        setShouldShowProjectName(false);
      }
    };

    fetchProjectData();
  }, [urlProjectId, setProjectName, handleAPIError]);

  return (
    <div className="h-screen flex flex-col overflow-auto">
      <Header projectName={shouldShowProjectName ? projectName : ''} />
      <Outlet />
    </div>
  );
}
